import { geoValuesEqual, GEO_TOLERANCE } from '../point/point.utils';

export const areQuaternionsEqual = (
  quaternion1: number[] | null,
  quaternion2: number[] | null,
  tolerance = GEO_TOLERANCE
): boolean => {
  if (!quaternion1 && !quaternion2) {
    return true;
  }

  return (
    !!quaternion1 &&
    !!quaternion2 &&
    quaternion1.length === quaternion2.length &&
    quaternion1.every((value, index) =>
      geoValuesEqual(value, quaternion2[index], tolerance)
    )
  );
};
